module.exports = __webpack_public_path__ + "img/chart.5cd484b7.png";